import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import './loading.css';

export default function Loading() {
    return (
        <div className="loader-view-block h-100">
            <div className="loader-view">
                <CircularProgress />
            </div>
        </div>
    );
}